import Icon from '../components/Icon.vue'

Icon.register({
  heading: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M496 80V48C496 39.2 488.8 32 480 32H320C311.2 32 304 39.2 304 48V80C304 88.8 311.2 96 320 96H357.6V224H154.4V96H192C200.8 96 208 88.8 208 80V48C208 39.2 200.8 32 192 32H32C23.2 32 16 39.2 16 48V80C16 88.8 23.2 96 32 96H69.3V416H32C23.2 416 16 423.2 16 432V464C16 472.8 23.2 480 32 480H192C200.8 480 208 472.8 208 464V432C208 423.2 200.8 416 192 416H154.4V288H357.6V416H320C311.2 416 304 423.2 304 432V464C304 472.8 311.2 480 320 480H480C488.8 480 496 472.8 496 464V432C496 423.2 488.8 416 480 416H442.7V96H480C488.8 96 496 88.8 496 80z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/heading.js
// module id = x0mf
// module chunks = 144